import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../modules/infra/i18n';

const Error = ({ username, shopName }) => (
  <div className="c-handoff-bar c-handoff-bar_error">
    <span className="u-fontsize-tiny u-type--bold u-co-white">{t('shops:handoff.error.title')}</span>
    <span style={{ paddingTop: '1px' }} className="u-fontsize-huge u-type--bold u-co-white u-mh-">
      &#183;
    </span>
    <span className="u-fontsize-tiny u-type--semibold u-co-white">
      {t('shops:handoff.error.message', { username, shopName })}
    </span>
  </div>
);

Error.propTypes = {
  username: PropTypes.string.isRequired,
  shopName: PropTypes.string.isRequired,
};

export default Error;
